import { render, staticRenderFns } from "./ExternalSite.vue?vue&type=template&id=52aba602"
import script from "./ExternalSite.vue?vue&type=script&lang=ts"
export * from "./ExternalSite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports